import { useState } from 'react'
import type { OrgItem } from '@/lib/apiTypes'
import { api } from '@/lib/api'
import { DangerConfirmModal } from '@/shared/components/DangerConfirmModal'
import { useToast } from '@/context/ToastContext'

export function DeleteOrgSection({ org }: { org: OrgItem }) {
  const { showToast } = useToast()
  const [showConfirm, setShowConfirm] = useState(false)
  const [busy, setBusy] = useState(false)

  const handleDelete = async () => {
    setBusy(true)
    try {
      await api.delete(`/api/orgs/${org.slug}`)
      showToast('Organisation deleted. Redirecting...', 'success')
      setTimeout(() => { window.location.href = '/' }, 1500)
    } catch (err) {
      showToast((err as Error).message, 'error')
    } finally {
      setBusy(false)
    }
  }

  return (
    <>
      <button
        className="btn btn-danger btn-sm"
        onClick={() => setShowConfirm(true)}
      >
        Delete organisation
      </button>

      {showConfirm && (
        <DangerConfirmModal
          track="org_delete_confirm"
          title="Delete organisation"
          confirmLabel="Delete organisation"
          confirmPhrase={org.slug}
          confirmHint={<>Type the organisation slug <code style={{ color: 'var(--accent)' }}>{org.slug}</code> to confirm:</>}
          message="This action cannot be undone. All modules, state files, and data will be permanently deleted in 30 days."
          busy={busy}
          onConfirm={handleDelete}
          onCancel={() => setShowConfirm(false)}
        />
      )}
    </>
  )
}
